import React from 'react';

const UserIDCon = React.createContext({});

export { UserIDCon };
